import axios from "axios";
import { WEBSITE_NAME } from "../../constants/CompanyConstants";

export const sendExceptionToSlack = (message) => {
  if (process.env.REACT_APP_ENVIRONMENT === "local") {
    console.log("SEND EXCEPTION TO SLACK", message);
    return;
  }
  let websiteName = WEBSITE_NAME;
  if (process.env.REACT_APP_ENVIRONMENT !== "production") websiteName += " DEV";

  axios
    .post("https://guardian.digitalkiss.nl/api/slack/exception", {
      project: websiteName,
      message,
    })
    .catch((err) => console.log(err));
};

export const sendLogToSlack = (message) => {
  if (process.env.REACT_APP_ENVIRONMENT === "local") return;
  let websiteName = WEBSITE_NAME;
  if (process.env.REACT_APP_ENVIRONMENT !== "production") websiteName += " DEV";

  axios
    .post("https://guardian.digitalkiss.nl/api/slack/log", {
      project: websiteName,
      message,
    })
    .catch((err) => console.log(err));
};
